<template>
 <div id="app" class="modal">
    <div class="modal-window">
        <div v-if="type == 'audio'" class="player">
            <audio controls>
                <source :src="source" type="audio/mpeg">
                Your browser does not support the audio element.
            </audio>
        </div>
        <div v-else class="player">
            <video width="400" controls>
                <source :src="source" type="video/mp4">
                <source :src="source" type="video/ogg">
                Your browser does not support HTML5 video.
            </video>
        </div>
        <div class="actions">
             <button class="cancel" @click="onCancel">Close</button>
        </div>
    </div>
 </div>
</template>

<script>
export default {
    name: 'MediaPlayer',
    props: {
        file: {
            type: String,
            default: null
        },
        mediaType: {
            type: String,
            default: null
        }
    },

    data () {
        return {
            type: this.mediaType,
            source: this.file
        }
    },

    mounted() {
        if (!this.file) {
            if (this.type == 'audio') {
                this.source = '../dist/sample.mp3';
            }
            else {
                this.source = '../dist/videoplayback.mp4';
            }
        }

    },

    methods: {
        onCancel() {
            this.$emit("cancel");
        }
    }
}
</script>

<style scoped>
.modal {
    position: fixed;
    top: 0;
    left: 0;
    bottom: 0;
    right: 0;
    background: rgba(0, 0, 0, .5);
    z-index: 2;
    width: 100%;
}

.modal-window {
    position: absolute;
    top: 50%;
    left: 50%;
    transition: .5s;
    width: 40%;
    min-width: 400px;
    max-width: 600px;
    background: white;
    box-shadow: 0 0 10px rgba(0, 0, 0, .5);
    transform: translate(-50%, -50%);
    padding: 1em;
    color: black;
    text-align: center;
}
.actions button {
    font-size: inherit;
    margin: 4px;
    border: none;
    padding: 6px 8px;
    cursor: pointer;
}

.actions .cancel {
    background: darkred;
    color: white;
}

.actions .confirm {
    background: darkcyan;
    color: white;
}
button {
    cursor: pointer;
}
</style>



// WEBPACK FOOTER //
// src/components/MediaPlayer.vue